<template>
  <van-tabbar v-model="index" route z-index="100000">
    <van-tabbar-item icon="video" to="/school">学习中心</van-tabbar-item>
    <van-tabbar-item icon="records" to="/exam">考试</van-tabbar-item>
    <van-tabbar-item icon="friends" to="/home">我的</van-tabbar-item>
  </van-tabbar>
</template>

<script>
export default {
  name: 'tabbar',
  props:['active'],
  computed:{
    index:{
      get(){
        return this.active
      },
      set(val){
        return val
      }
    }
  }
}
</script>
<style scoped></style>
